import { useMemo } from 'react';
import { NAV_ITEMS, isItemAccessible, getTimeTrackingItems } from '../config/navConfig';

// Single accessible-items computation shared by the sidebar (group visibility) and the
// quick-search index — mirrors the old Navbar.js `accessiblePages` memo (lines 282-289),
// with the Time Tracking manage/view-only branch special-cased via getTimeTrackingItems.
export default function useAccessibleNavItems({ isLoggedIn, hasModule, canReviewQA }) {
  return useMemo(() => {
    if (!isLoggedIn) return [];
    const timeTrackingIds = new Set(getTimeTrackingItems(hasModule).map(i => i.id));
    return NAV_ITEMS.filter(item => {
      if (item.group === 'timeTracking') return timeTrackingIds.has(item.id);
      return isItemAccessible(item, { hasModule, canReviewQA });
    });
  }, [isLoggedIn, hasModule, canReviewQA]);
}
